import "./gradient.css";
import Hh from "../assets/hh.png";
import ArrowEllipse from "../../common/ArrowEllipse";
import useIsMobile from "../../common/hooks/useIsMobile";
import { GuyStyle } from "./styles";
import Vitalii from "../assets/vitalii.png";
import Jane from "../assets/jane.png";
import David from "../assets/david.png";
import Nikitas from "../assets/nikitas.png";
import Alexey from "../assets/alexey.png";

const Job = () => {
  const isMobile = useIsMobile();

  const jobData = [
    <GuyStyle src={Vitalii} alt="job-guy" />,
    <GuyStyle src={Jane} alt="job-guy" />,
    <GuyStyle src={David} alt="job-guy" />,
    <GuyStyle src={Nikitas} alt="job-guy" />,
    <GuyStyle src={Alexey} alt="job-guy" />,
    <GuyStyle src={Hh} alt="job-guy" />,
  ];

  return (
    <>
      {[
        ...jobData,
        <ArrowEllipse
          size={!isMobile ? "2vw" : "4vw"}
          ellipsePadding={!isMobile ? "2vw" : "5vw"}
        />,
      ]}
    </>
  );
};

export const approaches = ["WEB", "Mobile", "Analytics", "ML", "Design"];

export const blockData = {
  stack: ["web", "mobile", "analytics", "ML", "design"],
  job: <Job />,
};

export const textData = {
  header: {
    title: "We build ambitious digital products",
  },
  projects: {
    details: {
      years: "9",
      projectTime: "2.2",
      timeNumber: "млн",
    },
    InIT: "лет в IT",
    users: "пользователей",
  },
  ourStackTitle: "Наши направления",
  approach: "Используем продуктовый подход к каждому проекту и заказчику",
  developingSpheres: "Развиваем отрасли",
  ourGoods: "Наши услуги",
  knowledge: "Передаём знания через практику",
  numbers: "В цифрах",

  services: {
    title1: "Наши услуги",
    title2: "Оформить заказ",
  },
  academy: "Академия",
  clients: "Заказчики",
  job: "Работа у нас",
};
